<div class="main-page-section default_font pt-3 pt-md-4 px-3 px-md-4 px-lg-5 d-flex flex-column">
    <div class="flex-fill">
        <div class="breadcrumbs-section p-0 mb-3 mb-md-4 mb-lg-5">
            <span class="prev-page pr-1 prev"><a routerLink="/overview">Home</a></span>
            <span class="separator">&nbsp; &nbsp;</span>
            <img src="../../assets/images/seperator.png">
            <span class="separator">&nbsp; &nbsp;</span>
            <span class="prev-page pr-1 prev"><a routerLink="/landscaping-and-vegetation">Add New Plant/Trees
                    Information</a></span>
            <span class="separator">&nbsp; &nbsp;</span>
            <img src="../../assets/images/seperator.png">
            <span class="separator">&nbsp; &nbsp;</span>
            <span class="prev-page pr-1 prev"><a routerLink="/list-of-plants-trees">View list of Plant/Trees</a></span>
            <span class="separator">&nbsp; &nbsp;</span>
            <img src="../../assets/images/seperator.png">
            <span class="separator">&nbsp; &nbsp;</span>
            <span class="curr-page pl-1 breadcrumbs-section-font">Plant Details</span>
        </div>
        <div class="d-flex align-items-center justify-content-between mb-3 mb-md-4">
            <h2 class="font-weight-bold mb-3 mb-md-4">{{plantDetails?.vegetationName}}</h2>
        </div>

        <!-- <div class="row row-gap-4 mb-4 mb-md-5">
            <div class="col-12 col-md-6 col-lg-4 col-xl-3"
                *ngFor='let url of alldetails.data.vegetationPhotos; let i = index'>
                <div class="view_uploaded_images">
                    <img [src]="url.vegetationPhotoPath">
                </div>
            </div>
        </div> -->

        <div class="mb-4 mb-md-5" *ngIf="plantDetails?.vegetationPhotos!=''">
            <div class="view_uploaded_images swiper">
                <div class="swiper-container">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide" *ngFor='let url of plantDetails?.vegetationPhotos; let i = index'>
                            <a [href]="url.vegetationPhotoPath" data-fancybox="gallery" [id]="url.vegetationPhotoId">
                                <img [src]="url.vegetationPhotoPath" [alt]="url.alt" [title]="url.title">
                            </a>
                        </div>
                    </div>
                    <div class="swiper-pagination"></div>
                </div>

                <!-- <owl-carousel-o [options]="customOptions">
                    <ng-container *ngFor='let url of plantDetails?.vegetationPhotos; let i = index'>
                        <ng-template carouselSlide [id]="url.vegetationPhotoId">
                            <a [href]="url.vegetationPhotoPath" data-fancybox="gallery">
                                <img [src]="url.vegetationPhotoPath" [alt]="url.alt" [title]="url.title">
                            </a>
                        </ng-template>
                    </ng-container>
                </owl-carousel-o> -->
                <!-- <ng-image-slider #nav [images]="imageObject" [infinite]="false" [autoSlide]="1"
                    [imageSize]="{width: '25%', height: 200}" slideImage="1"></ng-image-slider> -->
            </div>
        </div>

        <div class="row row-gap-4 mb-4 mb-md-5">
            <div class="col-12 col-md-6 col-lg-4 col-xl-3 d-flex flex-column row-gap-2">
                <small class="font-weight-light text-gray-medium">Name</small>
                <span class="font-weight-medium text-gray-dark">{{plantDetails?.vegetationName}}</span>
            </div>
            <div class="col-12 col-md-6 col-lg-4 col-xl-3 d-flex flex-column row-gap-2">
                <small class="font-weight-light text-gray-medium">Species</small>
                <span class="font-weight-medium text-gray-dark">{{plantDetails?.species}}</span>
            </div>
            <div class="col-12 col-md-6 col-lg-4 col-xl-3 d-flex flex-column row-gap-2">
                <small class="font-weight-light text-gray-medium">Location Details</small>
                <span class="font-weight-medium text-gray-dark">{{plantDetails?.parkName}}</span>
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-lg-8 col-lg-9 d-flex flex-column row-gap-2 row-gap-md-3"
                *ngIf="plantDetails?.vegetationNotes!=''">
                <p class="h5 font-weight-normal text-muted mb-0">Notes</p>

                <!-- <div class="d-flex flex-column row-gap-4" *ngFor='let note of alldetails.data.vegetationNotes; let i = index'>
                    <div class="d-flex flex-column row-gap-2">
                        <small class="font-weight-light text-gray-medium">Introduction</small>
                        <span class="font-weight-medium text-gray-dark">{{note.headline}}</span>
                    </div>
                    <div class="d-flex flex-column row-gap-2">
                        <small class="font-weight-light text-gray-medium">Plantation Details</small>
                        <span class="font-weight-medium text-gray-dark">{{note.description}}</span>
                    </div>
                </div> -->

                <div class="bg-lighter border border-light rounded p-3 p-md-4 d-flex flex-column row-gap-4"
                    *ngFor='let note of plantDetails?.vegetationNotes; let i = index'>
                    <div class="d-flex flex-column row-gap-2">
                        <small class="font-weight-light text-gray-medium">Introduction</small>
                        <span class="font-weight-medium text-gray-dark">{{note.headline}}</span>
                    </div>
                    <div class="d-flex flex-column row-gap-2">
                        <small class="font-weight-light text-gray-medium">Plantation Details</small>
                        <span class="font-weight-medium text-gray-dark">{{note.description}}</span>
                    </div>
                </div>
            </div>

            <div class="col-12 col-lg-8 col-lg-9 d-flex flex-column row-gap-2 row-gap-md-3"
                *ngIf="plantDetails?.vegetationNotes==''">
                <p class="h5 font-weight-normal text-muted mb-0">Notes</p>
                <p>No data available.</p>
            </div>
        </div>
    </div>
    <div
        class="details_footer shadow-lg py-3 py-md-4 d-flex align-items-center justify-content-end column-gap-3 mx-n3 mx-md-n4 mx-lg-n5 px-3 px-md-4 px-lg-5 mt-4 mt-md-5">
        <button class="btn btn-clear text-danger" (click)="openRemoveModal(plantId)"
            *ngIf="foodvendorRemove">Delete</button>
        <button class="btn btn-clear" (click)="goToEditPage();" *ngIf="foodvendorEdit">Edit Details</button>
        <button class="btn btn-clear" (click)="goToPrintPage();" *ngIf="foodvendorCreate">Print QR Code</button>
        <!-- <button class="btn btn-primary"(click)="openQrCodeModal(plantDetails?.qrCodePath, plantDetails?.vegetationName)">Download QR Code</button> -->
        <button class="btn btn-primary"
            (click)="openModal(plantDetails?.qrCodePath, plantDetails?.vegetationName, plantDetails?.vegetationId, plantDetails?.species, plantDetails?.parkName)"
            *ngIf="foodvendorCreate">Download
            QR
            Code</button>
    </div>
</div>